import { SvgIcon } from '@mui/material';
import React, { CSSProperties, ReactElement } from 'react';

export interface CheckCircleIconProps {
  style?: CSSProperties;
}

export const CheckCircleIcon = ({
  style,
}: CheckCircleIconProps): ReactElement => {
  return (
    <SvgIcon
      style={{
        fontSize: '1em',
        ...style,
      }}
      viewBox="0 0 18.16 18.16"
    >
      <path
        d="M9.08,0a9.08,9.08,0,1,0,9.08,9.08A9.09,9.09,0,0,0,9.08,0Zm0,17.025A7.945,7.945,0,1,1,17.025,9.08,7.954,7.954,0,0,1,9.08,17.025Z"
        fill="currentColor"
      />
      <path
        d="M146.067,199.2l-2.436-2.436-.8.8,3.239,3.239,5.509-5.509-.8-.8Z"
        transform="translate(-138.122 -188.087)"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
